import React, { useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

const BackAnchor = ({ t, i18n, backPath, onBackClick }) => {
    const history = useHistory()

    const handleGoBack = useCallback((e) => {
        e.preventDefault();
        if (onBackClick) {
            onBackClick();
        }

        backPath
            ? history.push(`/${i18n.language}${t(backPath)}`)
            : history.goBack();
    }, [history, onBackClick, backPath, i18n.language, t]);

    return (
        <div className="row">
            <div className="col-xs-12 col-md-8">
                <div style={{ marginTop: '20px' }}>
                    <a
                        onClick={handleGoBack}
                        href={`/${i18n.language}${t(backPath)}`}
                        className="ns-back-link"
                    >
                        {t('shared.back')}
                        <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default withTranslation('common')(BackAnchor)